import { AppConfig } from '@shared/interfaces';

export const INITIAL_CONFIG: AppConfig = {
    defaultLanguage: 'en'
};
